import { render, staticRenderFns } from "./HorizontalBackgroundTextImageSectionModule.vue?vue&type=template&id=1f0187be&"
import script from "./HorizontalBackgroundTextImageSectionModule.vue?vue&type=script&lang=js&"
export * from "./HorizontalBackgroundTextImageSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports